import styled from 'styled-components';
import { Row, Column } from '@simplywallst/ui-core';

export const NoDataWrapper = styled(Row)`
  height: 200px;
  background: ${({ theme }) => theme.color.spaceGray};
  p {
    margin: 0;
  }
`;

export { Column };
